/* eslint-disable no-invalid-this */
const NS = 'OnboardingPage';
const CLS = 'onboardingPage';

export class OnboardingPage {
    constructor(element) {
        const $this = this;
        this.element = element;
        this.$element = $(this.element);
        this.$tplScroller = $('.tpl-scroller');
        this.$form = this.$element.find('form');
        this.$formAction = this.$form.attr('action');
        this.$navDots = this.$element.find(`.${CLS}-stepper-nav-dots`);
        this.$progressBar = this.$element.find(`.${CLS}-progressBar-progress`);
        this.$totalSteps = 0;
        this.$currentStep = 0;
        
        // Init
        $.each($('[data-step]', this.$element), function() {
            const checkboxes = $(this).find(`input[type="checkbox"]`);
            const radios = $(this).find(`input[type="radio"]`);
            const select = $(this).find(`select`);
            const textarea = $(this).find(`textarea`);
            const inputtext = $(this).find(`input[type="text"]`);
            const nextBtn = $(this).find('[data-next-btn]');
            const prevBtn = $(this).find('.btn-text-link--prev');
            
            // Total questions
            if($(this).data('step') !== 'success') {
                $this.$totalSteps++;
            }

            // Field validation - radio
            radios.on('change', (event) => {
                nextBtn.removeClass('disabled');
            });
    
            // Field validation - checkboxes
            checkboxes.on('change', (event) => {
                if($(checkboxes).is(':checked') ) {
                    nextBtn.removeClass('disabled');
                }
                else {
                    nextBtn.addClass('disabled');
                }
            });
            
            select.on('change', (event) => {
                nextBtn.removeClass('disabled');
            });

            inputtext.on('change', (event) => {
                nextBtn.removeClass('disabled');
            });

            textarea.on('change', (event) => {
                nextBtn.removeClass('disabled');
            });

        });

        // Form back buttons
        this.$element.on('click', '.btn-text-link--prev', (event) => {
            event.preventDefault();

            // Current Slide
            let stepCurrentValue = $(event.currentTarget).data('stepCurrent');
            let stepCurrentTarget = this.$element.find(`[data-step='${stepCurrentValue}']`);

            // Update count
            if($(stepCurrentTarget).data('step') !== 'success') {
                if($(stepCurrentTarget).data('stepResult') !== 'true') {
                    this.$currentStep--;
                }
                $(stepCurrentTarget).data('stepResult', 'true');
            }

            // Next slide, or quiz end?
            let stepTargetValue = $(event.currentTarget).data('stepTarget');
                this.goToStep(stepTargetValue);
        });

        // Form skip / submit buttons
        this.$element.on('click', '.btn-text-link--next', (event) => {
            event.preventDefault();

            // Current Slide
            let stepCurrentValue = $(event.currentTarget).data('stepCurrent');
            let stepCurrentTarget = this.$element.find(`[data-step='${stepCurrentValue}']`);

            // Update count
            if($(stepCurrentTarget).data('step') !== 'success') {
                if($(stepCurrentTarget).data('stepResult') !== 'true') {
                    this.$currentStep++;
                }
                $(stepCurrentTarget).data('stepResult', 'true');
            }
            // Next slide, or quiz end?
            let stepTargetValue = $(event.currentTarget).data('stepTarget');
            if(stepTargetValue === 'submit') {
                // Submit
                // this.$element.find('form').trigger('submit');
                var array = this.$form.serializeArray();
                var formData = {};
                $.map(array, function (n, i) {
                    formData[n['name']] = n['value'];
                });

                // Removes empty field values
                _.forOwn(formData, (value, key) => {
                    if(_.isNil(value) || value.trim() === '') {
                        delete formData[key];
                    }
                });

                var json_text = JSON.stringify(formData);
                let request = new Request(this.$formAction, {
                    method: 'POST',
                    body: json_text,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                // submit form data using fetch api
                fetch(request)
                    .then((response) => {
                        if(response.status === 200) {
                            $this.goToStep('success');
                            $this.$navDots.hide();
                        }
                        else {
                            response.statusText;
                        }
                    })
                    .catch((error) => {
                        // errors (failed call)
                        response.error;
                    });
            }
            else {
                // Next Slide
                this.goToStep(stepTargetValue);
            }
        });

        // Form next / submit buttons
        this.$element.on('click', '[data-next-btn]', (event) => {
            event.preventDefault();

            // Current Slide
            let stepCurrentValue = $(event.currentTarget).data('stepCurrent');
            let stepCurrentTarget = this.$element.find(`[data-step='${stepCurrentValue}']`);
            // Update count
            if($(stepCurrentTarget).data('step') !== 'success') {
                if($(stepCurrentTarget).data('stepResult') !== 'true') {
                    this.$currentStep++;
                }
                $(stepCurrentTarget).data('stepResult', 'true');
            }

            // Next slide, or quiz end?
            let stepTargetValue = $(event.currentTarget).data('stepTarget');

                var array = this.$form.serializeArray();
                var formData = {};
                $.map(array, function (n, i) {
                    formData[n['name']] = n['value'];
                });

                // Removes empty field values
                _.forOwn(formData, (value, key) => {
                    if(_.isNil(value) || value.trim() === '') {
                        delete formData[key];
                    }
                });

                var json_text = JSON.stringify(formData);
                let request = new Request(this.$formAction, {
                    method: 'POST',
                    body: json_text,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                // submit form data using fetch api
                fetch(request)
                    .then((response) => {
                        if(response.status === 200) {
                            if(stepTargetValue === 'submit') {
                                $this.goToStep('success');
                            }
                            else{
                                $this.goToStep(stepTargetValue);
                            }
                            $this.$navDots.hide();
                        }
                        else {
                            response.statusText;
                        }
                    })
                    .catch((error) => {
                        // errors (failed call)
                        response.error;
                    });
        });
    }

    // Go to slide
    goToStep(stepTargetValue) {
        // Hide current slide
        this.$element.find('[data-step]').not(`[data-step='${stepTargetValue}']`).fadeOut(0).removeClass('is-active');

        // Show new slide
        let $stepTarget = this.$element.find(`[data-step='${stepTargetValue}']`);
        $stepTarget.fadeIn(250).addClass('is-active');

        // Update dots
        this.$element.find('[data-dots-btn]').removeClass('active');
        this.$element.find(`.${CLS}-stepper-nav-dots-dot[data-step-target='${stepTargetValue}']`).addClass('active');
    }
}